import Vue from 'vue';
import Router from 'vue-router';
import { Message } from 'element-ui';
import store from '@/page/store';
import { generateRoutes } from '@/utils/env';
Vue.use(Router);

export default ctx => {
  const router = new Router({
    linkExactActiveClass: 'active',
    mode: 'history',
    routes: generateRoutes(ctx)
  });
  // 注册全局路由守卫进行路由鉴权
  router.beforeEach((to, from, next) => {
    if (to.path === '/') {
      return next('/home');
    }

    if (to.path.indexOf('/userinfo') >= 0) {
      // 检测localstorage是否存在token
      if (!localStorage.getItem('TOKEN')) {
        Message.error('请先登录');
        return next('/login');
      }
    }

    next();
  })

  router.afterEach((to,from,next) => {
    if (from.path === '/home') {
      window.scrollTo(0,0);
    }
  })

  //   next();
  // });

  return router;
};

